import { render, staticRenderFns } from "./complaintPop.vue?vue&type=template&id=7f217e17&scoped=true&"
import script from "./complaintPop.vue?vue&type=script&lang=js&"
export * from "./complaintPop.vue?vue&type=script&lang=js&"
import style0 from "./complaintPop.vue?vue&type=style&index=0&id=7f217e17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f217e17",
  null
  
)

export default component.exports